import { NavigationItemType } from 'core/slices/models';

export const findReport = (node: any, reportId?: string): any => {
  if (node.nodeType === NavigationItemType.REPORT && node.id === reportId) {
    return node;
  }
  if (node.children) {
    for (const child of node.children) {
      const found = findReport(child, reportId);
      if (found) return found;
    }
  }
  return null;
};
